var exports = {
  "Qs": "DebugModal.module__content___TnBoSU",
  "kL": "DebugModal.module__container___TnBoSU",
  "sN": "DebugModal.module__tabsSection___TnBoSU",
  "vR": "DebugModal.module__tabs___TnBoSU",
  "P1": "DebugModal.module__scrollArea___TnBoSU",
  "z": "DebugModal.module__summary___TnBoSU",
  "hZ": "DebugModal.module__summaryTitle___TnBoSU",
  "D_": "DebugModal.module__summaryBody___TnBoSU",
  "Ip": "DebugModal.module__summaryItem___TnBoSU",
  "rG": "DebugModal.module__summaryLabel___TnBoSU",
  "Qb": "DebugModal.module__summaryValue___TnBoSU",
  "ZP": "DebugModal.module__codeSection___TnBoSU",
  "Dy": "DebugModal.module__codeSurface___TnBoSU",
};

module.exports = exports;
